import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inner" }




export default /*@__PURE__*/_defineComponent({
  __name: 'HeadingEmphasis',
  props: {
  secondary: Boolean,
},
  setup(__props) {

/**
 * This component exists to be styled by the `app-overrides.scss` file.
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["bcl-heading-emphasis", [__props.secondary ? 'text-secondary' : 'text-primary']])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})